import jsPDF from 'jspdf';
import moment from 'moment'

function formatoCantidad(numero) {
    let respuesta = numero.toFixed(3);
    return respuesta;
}

function formatoImpuestos(numero) {
    let respuesta = numero.toFixed(4);
    return respuesta;
}

function formatoNumerico(value) {
    return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function formtaoFecha(value) {
    moment.locale('es');
    return moment(value).format('DD-MMMM-YYYY HH:mm:ss')
}

const ComprobanteNominaBase64 = async (ObjComprobante, ObjTipoComprobante, ObjEstatus, ObjColor, ObjQr) => {
    return new Promise((resolve, reject) => {
        try {
            const doc = new jsPDF();
            //CABECERA 
            let xCabecera = 10;
            let yCabecera = 15;

            //DATOS DE LA EMPRESA
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text(ObjTipoComprobante + ' ' + ObjComprobante.serie + ' ' + ObjComprobante.folio, 200, yCabecera, { align: 'right' });
            doc.setFontSize(12);
            doc.setFont('helvetica', 'normal');
            doc.text(ObjComprobante.emisor.rfc, 200, yCabecera += 5, { align: 'right' });
            doc.text(ObjComprobante.emisor.nombre, 200, yCabecera += 5, { align: 'right' });
            doc.setFontSize(9);
            doc.text(ObjComprobante.emisor.regimenFiscal.regimenFiscal, 200, yCabecera += 5, { align: 'right' });
            doc.text(ObjComprobante.lugarExpedicion, 200, yCabecera += 5, { align: 'right' });
            doc.text(formtaoFecha(ObjComprobante.fecha), 200, yCabecera += 5, { align: 'right' });

            //DATOS DEL TRABAJADOR
            yCabecera += 2
            let ObjTrabajador = { ...ObjComprobante.nomina.receptor }
            let xTrabajadore = 10;
            let yTrabajador = yCabecera;
            let width = 115;
            let height = 5;
            let cornerRadius = 2;
            let color = [64, 125, 250]
            let tipoRegimen = doc.splitTextToSize(ObjTrabajador.tipoRegimen.tipoRegimen, 80)
            let tipoRegimenHeight = doc.getTextDimensions(tipoRegimen).h;

            doc.setFillColor(ObjColor);
            doc.setDrawColor(ObjColor);
            doc.roundedRect(xTrabajadore, yTrabajador, width, height, cornerRadius, cornerRadius, 'FD');
            //NOMBRE DEL TRABAJADOR
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(255, 255, 255); // Blanco
            doc.text(ObjTrabajador.numEmpleado + ' | ' + ObjComprobante.receptor.nombre, 60, yTrabajador + 4, { align: 'center' });

            //TEXTOS
            doc.setFontSize(9);
            yTrabajador += 6;
            let yyTrabajador = yTrabajador
            doc.setTextColor(0, 0, 0);
            doc.text('RFC:', xTrabajadore, yTrabajador += 4);
            doc.text('CURP:', xTrabajadore, yTrabajador += 4);
            doc.text('Tipo Contrato:', xTrabajadore, yTrabajador += 4);
            doc.text('Tipo Régimen:', xTrabajadore, yTrabajador += 4);
            yTrabajador += tipoRegimenHeight
            doc.text('Periodicidad:', xTrabajadore, yTrabajador);
            doc.text('Clave Ent Fed:', xTrabajadore, yTrabajador += 4);
            if (ObjTrabajador.tipoRegimen.clave === '02') {
                doc.text('NSS:', xTrabajadore, yTrabajador += 4);
                doc.text('Fecha Inicio Rel. Lab:', xTrabajadore, yTrabajador += 4);
                doc.text('Antigüedad:', xTrabajadore, yTrabajador += 4);
                doc.text('Riesgo Puesto:', xTrabajadore, yTrabajador += 4);
                doc.text('Departamento:', xTrabajadore, yTrabajador += 4);
                doc.text('Puesto:', xTrabajadore, yTrabajador += 4);
            }
            doc.text('Domicilio Fiscal:', xTrabajadore, yTrabajador += 4);

            //DATOS
            let xDatos = 45
            doc.setFont('helvetica', 'normal');
            doc.text(ObjComprobante.receptor.rfc, xDatos, yyTrabajador += 4);
            doc.text(ObjTrabajador.curp, xDatos, yyTrabajador += 4);
            doc.text(ObjTrabajador.tipoContrato.tipoContrato, xDatos, yyTrabajador += 4);
            doc.text(tipoRegimen, xDatos, yyTrabajador += 4);
            yyTrabajador += tipoRegimenHeight;
            doc.text(ObjTrabajador.periodicidadPago.periodicidadPago, xDatos, yyTrabajador);
            let claveEntFed = '';
            if (ObjTrabajador.claveEntFed) {
                claveEntFed = ObjTrabajador.claveEntFed.claveEntFed;
            }
            doc.text(claveEntFed, xDatos, yyTrabajador += 4);
            if (ObjTrabajador.tipoRegimen.clave === '02') {
                doc.text(ObjTrabajador.numSeguridadSocial, xDatos, yyTrabajador += 4);
                doc.text(formtaoFecha(ObjTrabajador.fechaInicioRelLaboral), xDatos, yyTrabajador += 4);
                doc.text(ObjTrabajador.antiguedad, xDatos, yyTrabajador += 4);
                doc.text(ObjTrabajador.riesgoPuesto.riesgoPuesto, xDatos, yyTrabajador += 4);
                var departamento = ObjTrabajador.departamento !== null ? ObjTrabajador.departamento : " ";
                doc.text(departamento, xDatos, yyTrabajador += 4);
                var puesto = ObjTrabajador.puesto !== null ? ObjTrabajador.puesto : " ";
                doc.text(puesto, xDatos, yyTrabajador += 4);
            }
            doc.text(ObjComprobante.receptor.domicilioFiscalReceptor, xDatos, yyTrabajador += 4);

            //DATOS DEL PAGO
            let yPagos = yCabecera
            let xPagos = 130;
            let yyPagos = 0;
            let xxPagos = 165;

            doc.setFillColor(ObjColor);
            doc.setDrawColor(ObjColor);
            doc.roundedRect(130, yPagos, 70, 5, 2, 2, 'FD');
            doc.setFontSize(12);
            doc.setFont('helvetica', 'bold');
            doc.setTextColor(255, 255, 255); // Blanco
            doc.text('PAGOS', 165, yPagos += 4, { align: 'center' });
            yyPagos = yPagos;
            doc.setFontSize(9);
            doc.setTextColor(0, 0, 0);
            doc.text('Tipo de Nómina:', xPagos, yPagos += 6);
            doc.text('Fecha Inicial: :', xPagos, yPagos += 4);
            doc.text('Fecha Final:', xPagos, yPagos += 4);
            doc.text('Fecha de Pago:', xPagos, yPagos += 4);
            doc.text('Num Días:', xPagos, yPagos += 4);
            if (ObjTrabajador.tipoJornada) {
                if (ObjTrabajador.tipoJornada.tipoJornada) {
                    doc.text('Tipo Jornada:', xPagos, yPagos += 4);
                }
            }
            doc.text('Total Percepciones:', xPagos, yPagos += 4);
            doc.text('Total Deducciones:', xPagos, yPagos += 4);
            doc.text('Total Otros Pagos:', xPagos, yPagos += 4);
            if (ObjTrabajador.tipoRegimen.clave === '02') {
                doc.text('Salario Base Cot Apor:', xPagos, yPagos += 4);
                doc.text('S.D.I.:', xPagos, yPagos += 4);
            }

            doc.setFont('helvetica', 'normal');
            doc.text(ObjComprobante.nomina.tipoNomina.tipoNomina, xxPagos, yyPagos += 6);
            doc.text(formtaoFecha(ObjComprobante.nomina.fechaInicialPago), xxPagos, yyPagos += 4);
            doc.text(formtaoFecha(ObjComprobante.nomina.fechaFinalPago), xxPagos, yyPagos += 4);
            doc.text(formtaoFecha(ObjComprobante.nomina.fechaPago), xxPagos, yyPagos += 4);
            doc.text(formatoCantidad(ObjComprobante.nomina.numdiasPagados), xxPagos, yyPagos += 4);
            if (ObjComprobante.nomina.receptor.tipoJornada) {
                if (ObjComprobante.nomina.receptor.tipoJornada.tipoJornada) {
                    doc.text(ObjComprobante.nomina.receptor.tipoJornada.tipoJornada, xxPagos, yyPagos += 4);
                }
            }
            doc.text(formatoNumerico(ObjComprobante.nomina.totalPercepciones), xxPagos, yyPagos += 4);
            doc.text(formatoNumerico(ObjComprobante.nomina.totalDeducciones), xxPagos, yyPagos += 4);
            doc.text(formatoNumerico(ObjComprobante.nomina.totalOtrosPagos), xxPagos, yyPagos += 4);
            if (ObjTrabajador.tipoRegimen.clave === '02') {
                doc.text(formatoNumerico(ObjComprobante.nomina.receptor.salarioBaseCotApor), xxPagos, yyPagos += 4);
                doc.text(formatoNumerico(ObjComprobante.nomina.receptor.salarioDiarioIntegrado), xxPagos, yyPagos += 4);
            }

            //APARTADO DE CONCEPTOS
            // let yConceptos = yyPagos + 4
            let yConceptos = yTrabajador + 4
            if (yyPagos > yTrabajador) {
                yConceptos = yyPagos + 4
            }
            let yyConceptos = yyPagos + 4
            doc.setFillColor(ObjColor);
            doc.setDrawColor(ObjColor);
            doc.roundedRect(10, yConceptos, 190, 5, 2, 2, 'FD');
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(12);
            doc.setTextColor(255, 255, 255); // Blanco
            doc.text('CONCEPTOS', 100, yConceptos += 4, { align: 'center' });

            //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
            //PRIMERO LA CABACERA
            doc.setTextColor(0, 0, 0); // NEGRO
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            let xDescripcion = 10;
            let xCantidad = 115;
            let xClaveUnidad = 138;
            let xValorUnitario = 175;
            let xImporte = 200;
            yConceptos += 5

            doc.text('Descripción', xDescripcion, yConceptos, { align: 'left' });
            doc.text('Cantidad', xCantidad, yConceptos, { align: 'center' });
            doc.text('Clave Unidad', xClaveUnidad, yConceptos, { align: 'center' });
            doc.text('Valor Unitario', xValorUnitario, yConceptos, { align: 'right' });
            doc.text('Importe', xImporte, yConceptos, { align: 'right' });
            doc.line(xDescripcion, yConceptos += 1, xImporte, yConceptos + 1);
            //RECORREMOS LA LISTA DE CONCEPTOS Y CREAMOS LA TABLA MANUALMENTE
            yyConceptos = yConceptos + 7;
            for (let c_ of ObjComprobante.conceptos) {
                doc.setFont('helvetica', 'bold');
                doc.text(c_.descripcion, xDescripcion, yConceptos += 4, { align: 'left' });
                doc.setFont('helvetica', 'normal');
                doc.text(formatoCantidad(c_.cantidad), xCantidad, yyConceptos, { align: 'center' });
                doc.text(c_.claveUnidad.claveUnidad, xClaveUnidad, yyConceptos, { align: 'center' });
                doc.text(formatoNumerico(c_.valorUnitario), xValorUnitario, yyConceptos, { align: 'right' });
                doc.text(formatoNumerico(c_.importe), xImporte, yyConceptos, { align: 'right' });

                let claveProdServ = doc.splitTextToSize(c_.claveProdServ.claveProdServ, 105)
                let claveProdServHeight = doc.getTextDimensions(claveProdServ).h;
                doc.text(claveProdServ, xDescripcion, yConceptos += 4, { align: 'left' });
                yConceptos += claveProdServHeight - 1
                doc.line(xDescripcion, yConceptos, xImporte, yConceptos);
                yyConceptos += 4
            }

            //PERCEPRIONES
            let yPercepciones = yConceptos += 4
            if (ObjComprobante.nomina.percepciones.percepcion.length != 0) {
                let yyPercepciones = yPercepciones
                doc.setFillColor(ObjColor);
                doc.setDrawColor(ObjColor);
                doc.roundedRect(10, yConceptos, 190, 5, 2, 2, 'FD');
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(12);
                doc.setTextColor(255, 255, 255); // Blanco
                doc.text('PERCEPCIONES', 100, yConceptos += 4, { align: 'center' });

                //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                //PRIMERO LA CABACERA
                doc.setTextColor(0, 0, 0); // NEGRO
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(10);
                let xClaveP = 10;
                let xDescripcionP = 30;
                let xGravadoP = 150;
                let xExentoP = 200;
                yPercepciones += 9

                doc.text('Clave', xClaveP, yPercepciones, { align: 'left' });
                doc.text('Concepto', xDescripcionP, yPercepciones, { align: 'left' });
                doc.text('Importe Gravado', xGravadoP, yPercepciones, { align: 'right' });
                doc.text('Importe Exento', xExentoP, yPercepciones, { align: 'right' });
                doc.line(xClaveP, yPercepciones += 1, xExentoP, yPercepciones + 1);

                //RECORREMOS LA TABLA DE PERCEPCIONES PARA MOSTRARLOS EN PANTALLA
                yyPercepciones += 10
                for (let p_ of ObjComprobante.nomina.percepciones.percepcion) {
                    doc.setFont('helvetica', 'bold');
                    doc.text(p_.concepto, xDescripcionP, yPercepciones += 4, { align: 'left' });
                    doc.setFont('helvetica', 'normal');
                    doc.text(p_.tipoPercepcion.tipoPercepcion, xDescripcionP, yPercepciones += 4, { align: 'left' });
                    doc.text(p_.clave, xClaveP, yyPercepciones += 6, { align: 'left' });
                    doc.text(formatoNumerico(p_.importeGravado), xGravadoP, yyPercepciones, { align: 'right' });
                    doc.text(formatoNumerico(p_.importeExento), xExentoP, yyPercepciones, { align: 'right' });
                    yPercepciones += 2
                    doc.line(xClaveP, yPercepciones, xExentoP, yPercepciones);
                    yyPercepciones += 4
                }
            }

            // DEDUCCIONES
            let yDeducciones = yPercepciones += 4
            if (ObjComprobante.nomina.deducciones) {
                if (ObjComprobante.nomina.deducciones.deduccion.length != 0) {
                    let yyDeducciones = yDeducciones
                    doc.setFillColor(ObjColor);
                    doc.setDrawColor(ObjColor);
                    doc.roundedRect(10, yDeducciones, 190, 5, 2, 2, 'FD');
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(12);
                    doc.setTextColor(255, 255, 255); // Blanco
                    doc.text('DEDUCCIONES', 100, yDeducciones += 4, { align: 'center' });

                    //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                    //PRIMERO LA CABACERA
                    doc.setTextColor(0, 0, 0); // NEGRO
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(10);
                    let xClaveD = 10;
                    let xDescripcionD = 30;
                    let xImporteD = 200;
                    yDeducciones += 5

                    doc.text('Clave', xClaveD, yDeducciones, { align: 'left' });
                    doc.text('Concepto', xDescripcionD, yDeducciones, { align: 'left' });
                    doc.text('Importe', xImporteD, yDeducciones, { align: 'right' });
                    doc.line(xClaveD, yDeducciones += 1, xImporteD, yDeducciones + 1);
                    yyDeducciones += 10;

                    //CREAMOS LOS REGISTROS
                    for (let d_ of ObjComprobante.nomina.deducciones.deduccion) {
                        doc.setFont('helvetica', 'bold');
                        let cDeduccion = doc.splitTextToSize(d_.concepto, 120);
                        let cDeduccion_Height = doc.getTextDimensions(cDeduccion).h;

                        doc.text(cDeduccion, xDescripcionD, yDeducciones += 4, { align: 'left' });

                        doc.setFont('helvetica', 'normal');
                        doc.text(d_.tipoDeduccion.tipoDeduccion, xDescripcionD, yDeducciones += cDeduccion_Height, { align: 'left' });
                        doc.text(d_.clave, xClaveD, yyDeducciones += 6, { align: 'left' });
                        doc.text(formatoNumerico(d_.importe), xImporteD, yyDeducciones, { align: 'right' });
                        yDeducciones += 2
                        doc.line(xClaveD, yDeducciones, xImporteD, yDeducciones);
                        yyDeducciones += 4
                    }
                }
            }

            //OTROS PAGOS
            let yOtros = yDeducciones += 4
            if (ObjComprobante.nomina.otrosPagos) {
                if (ObjComprobante.nomina.otrosPagos.length != 0) {
                    let yyOtros = yOtros
                    doc.setFillColor(ObjColor);
                    doc.setDrawColor(ObjColor);
                    doc.roundedRect(10, yOtros, 190, 5, 2, 2, 'FD');
                    doc.setFont('helvetica', 'bold');
                    doc.setFontSize(12);
                    doc.setTextColor(255, 255, 255); // Blanco
                    doc.text('OTROS PAGOS', 100, yOtros += 4, { align: 'center' });

                    //INICIA LA TABLA QUE SE DIBUJA CON UN FOR Y LOS REGISTROS
                    //PRIMERO LA CABACERA
                    doc.setTextColor(0, 0, 0); // NEGRO
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(10);
                    let xClaveO = 10;
                    let xDescripcionO = 30;
                    let xImporteO = 200;
                    yOtros += 5

                    doc.text('Clave', xClaveO, yOtros, { align: 'left' });
                    doc.text('Concepto', xDescripcionO, yOtros, { align: 'left' });
                    doc.text('Importe', xImporteO, yOtros, { align: 'right' });
                    doc.line(xClaveO, yOtros += 1, xImporteO, yOtros + 1);
                    yyOtros += 10;

                    //CREAMOS LOS REGISTROS
                    for (let o_ of ObjComprobante.nomina.otrosPagos) {
                        doc.setFont('helvetica', 'bold');
                        doc.text(o_.concepto, xDescripcionO, yOtros += 4, { align: 'left' });
                        doc.setFont('helvetica', 'normal');
                        let otroP = doc.splitTextToSize(o_.tipoOtroPago.tipoOtroPago, 120);
                        let otroP_Height = doc.getTextDimensions(otroP).h;
                        doc.text(otroP, xDescripcionO, yOtros += 4, { align: 'left' });
                        doc.text(o_.clave, xClaveO, yyOtros += 6, { align: 'left' });
                        doc.text(formatoNumerico(o_.importe), xImporteO, yyOtros, { align: 'right' });
                        yOtros += otroP_Height
                        doc.line(xClaveO, yOtros, xImporteO, yOtros);
                        yyOtros += 4

                        //INSERTMOS EL SALTO DE PAGINA
                        let espacioDisponible = doc.internal.pageSize.height - 40;
                        let dif = yOtros > espacioDisponible
                        if (dif) {
                            doc.addPage();
                            yOtros = 10;
                            yyOtros = 10;
                        } else {
                            yOtros += otroP_Height
                            // doc.line(xClaveO, yOtros, 200, yOtros);
                            yOtros += 4;
                        }
                    }
                }

                let espacioDisponibleL = doc.internal.pageSize.height - 50;
                let difL = yOtros > espacioDisponibleL
                if (difL) {
                    yOtros = 10
                    doc.addPage();
                }
            }

            //APARTADO DEL IMPORTE CON LETRA
            let xImporteLetra = 10
            let yImporteLetra = yOtros - 4
            let yyImporteLetra = yOtros - 4
            const func = require('./numeroALetras.js')
            let importeLetra = func.numeroALetras(ObjComprobante.total, 'MXN');

            yImporteLetra += 5
            doc.setFontSize(9);
            doc.setFont('helvetica', 'bold');
            doc.text('Importe con Letra: ', xImporteLetra, yImporteLetra, { align: 'left' });
            doc.setFont('helvetica', 'normal');
            doc.text(importeLetra, xImporteLetra + 5, yyImporteLetra += 9, { align: 'left' });

            //APARTADO DE IMPORTES
            let ArrayImportes = []
            let ObjSubTotal = { descripcion: 'SubTotal:', importe: formatoNumerico(ObjComprobante.subTotal) }
            let ObjDescuento = { descripcion: 'Descuento:', importe: formatoNumerico(ObjComprobante.descuento) }
            let ObjTotal = { descripcion: 'Total:', importe: formatoNumerico(ObjComprobante.total) }
            let xImportes = 150
            let xxImportes = 200;
            ArrayImportes.push(ObjSubTotal);
            ArrayImportes.push(ObjDescuento);
            ArrayImportes.push(ObjTotal);
            //CREAMOS LOS REGISTROS
            for (let imp_ of ArrayImportes) {
                doc.setFont('helvetica', 'normal');
                doc.setFontSize(12);
                if (imp_.descripcion === 'Total:') {
                    doc.setFont('helvetica', 'bold');
                }
                doc.text(imp_.descripcion, xImportes, yImporteLetra, { align: 'left' });
                doc.text(imp_.importe, xxImportes, yImporteLetra, { align: 'right' });
                yOtros += 2
                yImporteLetra += 1
                doc.line(xImportes, yImporteLetra + 1, xxImportes, yImporteLetra + 1);
                yImporteLetra += 6
            }

            //DATOS FISCALES
            doc.setFontSize(9);
            let yCertificados = yyImporteLetra + 6;
            let xCertificado = 45;
            doc.text('Fecha de Timbrado: ', xImporteLetra, yyImporteLetra += 6);
            doc.text('No. Certificado: ', xImporteLetra, yyImporteLetra += 4);
            doc.text('No. Certificado SAT: ', xImporteLetra, yyImporteLetra += 4);
            doc.text('Folio FIscal: ', xImporteLetra, yyImporteLetra += 4);

            doc.setFont('helvetica', 'normal');
            doc.text(ObjComprobante.timbreFiscalDigital.fechaTimbrado, xCertificado, yCertificados);
            doc.text(ObjComprobante.timbreFiscalDigital.noCertificado, xCertificado, yCertificados += 4);
            doc.text(ObjComprobante.timbreFiscalDigital.noCertificadoSAT, xCertificado, yCertificados += 4);
            doc.text(ObjComprobante.folioFiscal, xCertificado, yCertificados += 4);

            //APARTADO DE LA FIRMA
            let yFirma = 0;
            let xFirma = 100
            if (yCertificados >= yImporteLetra) {
                yFirma = yCertificados += 6
            } else {
                yFirma = yImporteLetra += 6
            }
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(12);
            doc.setDrawColor('#000000');
            yFirma += 10
            doc.line(40, yFirma, 160, yFirma);
            doc.text(ObjComprobante.receptor.nombre, xFirma, yFirma += 6, { align: 'center' });

            let xSellos = 54
            let ySellos = yFirma + 10
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(6);

            let selloCfdi_ = doc.splitTextToSize(ObjComprobante.timbreFiscalDigital.selloCFD, 145);
            // let selloCfdi_ = '';
            let selloCfdi_Height = doc.getTextDimensions(selloCfdi_).h;
            // let selloCfdi_Height = 4;
            let selloSat_ = doc.splitTextToSize(ObjComprobante.timbreFiscalDigital.selloSAT, 145);
            // let selloSat_ = '';
            let selloSat_Height = doc.getTextDimensions(selloSat_).h;
            // let selloSat_Height = 4;
            let cadenaOriginal = doc.splitTextToSize(ObjComprobante.timbreFiscalDigital.cadenaOriginal, 145);
            // let cadenaOriginal = '';
            let cadenaOriginal_Height = doc.getTextDimensions(selloSat_Height).h;
            // let cadenaOriginal_Height = 4;

            let espacioDisponible = doc.internal.pageSize.height - 50;
            let dif = ySellos > espacioDisponible
            if (dif) {
                ySellos = 10
                doc.addPage();
            }

            let yQr = ySellos;
            doc.setFont('helvetica', 'bold');
            doc.text('Sello CFDI: ', xSellos, ySellos)
            doc.text('Sello SAT: ', xSellos, ySellos + selloCfdi_Height + 3)
            doc.text('Cadena Original: ', xSellos, ySellos + selloCfdi_Height + selloSat_Height + 6)

            doc.setFont('helvetica', 'normal');
            doc.text(selloCfdi_, xSellos, ySellos += 3);
            doc.text(selloSat_, xSellos, ySellos += selloCfdi_Height += 3);
            doc.text(cadenaOriginal, xSellos, ySellos += selloSat_Height += 3);

            //INSERTAMOS EL QR
            doc.addImage(ObjQr, 'PNG', 10, yQr, 44, 44);

            //DATOS FINALES PARA EXPORTAR EL ARCHIVO
            const base64 = doc.output('datauristring');
            let nombreDoc = '';
            if (ObjComprobante.serie === '') {
                nombreDoc = ObjComprobante.folio + '_' + ObjComprobante.receptor.rfc + '_' + ObjComprobante.folioFiscal
            } else {
                nombreDoc = ObjComprobante.serie + '_' + ObjComprobante.folio + '_' + ObjComprobante.receptor.rfc + '_' + ObjComprobante.folioFiscal
            }
            // doc.save(nombreDoc + '.pdf');
            resolve(base64);
        } catch (error) {
            console.log('ERROR', error)
        }
    });
};

export { ComprobanteNominaBase64 };